import React, { useState, useContext } from 'react'
import sublinks from './data';

const AppContext = React.createContext();

export const AppProvider = ({ children }) => 
{
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);
  const [ location, setLocation ] = useState({});
  const [subMenu, setSubMenu] = useState({  page : '', links : [] });

  const openSidebar = () => 
  {
    setIsSidebarOpen(true);
  }

  const closeSidebar = () => 
  {
    setIsSidebarOpen(false);
  }

  const openSubmenu = (page, coordinates) => 
  {
    const sublink = sublinks.find((link)=> { return page === link.page});
    setLocation(coordinates);
    setSubMenu(sublink);
    setIsSubmenuOpen(true);
  }

  const closeSubmenu = () => 
  {
    setIsSubmenuOpen(false);
  }

  return (
    <AppContext.Provider
      value={{
        location,
        subMenu,
        isSidebarOpen,
        isSubmenuOpen,
        openSubmenu,
        closeSubmenu,
        openSidebar,
        closeSidebar,
      }}
    >
      {children}
    </AppContext.Provider>)
};

export const useGlobalContext = () => 
{
  return useContext(AppContext);
}

